// ======= Swatch Navigation Controller =========
(function() {
  'use strict';
  
  const SCROLL_AMOUNT_GRID = 150;
  const SCROLL_AMOUNT_PRODUCT = 250;
  const INIT_MARK = 'data-swatch-nav-initialized';

  // --- Reusable initializer for any grid product card ---
  function initGridSwatchNavigation(container) {
    if (container.hasAttribute(INIT_MARK)) return;
    container.setAttribute(INIT_MARK, 'true');

    const swatchContainer = container.querySelector('.grid-product__colors_top');
    const leftButton = container.querySelector('.swatch-navigation-wrapper[navigation="left"]');
    const rightButton = container.querySelector('.swatch-navigation-wrapper[navigation="right"]');

    if (!swatchContainer || !leftButton || !rightButton) return;

    function updateNavigation() {
      const maxScroll = swatchContainer.scrollWidth - swatchContainer.clientWidth;
      const scrollLeft = swatchContainer.scrollLeft;

      if (scrollLeft <= 5) {
        leftButton.classList.remove('star-show');
      } else {
        leftButton.classList.add('star-show');
      }

      if (scrollLeft >= maxScroll - 5 || maxScroll <= 0) {
        rightButton.classList.remove('star-show');
      } else {
        rightButton.classList.add('star-show');
      }
    }

    rightButton.addEventListener('click', function (e) {
      e.stopPropagation();
      const maxScroll = swatchContainer.scrollWidth - swatchContainer.clientWidth;
      swatchContainer.scrollTo({
        left: Math.min(swatchContainer.scrollLeft + SCROLL_AMOUNT_GRID, maxScroll),
        behavior: 'smooth'
      });
    });

    leftButton.addEventListener('click', function (e) {
      e.stopPropagation();
      swatchContainer.scrollTo({
        left: Math.max(swatchContainer.scrollLeft - SCROLL_AMOUNT_GRID, 0),
        behavior: 'smooth'
      });
    });

    swatchContainer.addEventListener('scroll', updateNavigation);
    window.addEventListener('resize', updateNavigation);
    updateNavigation();
  }

  // --- Product page variant swatch initializer ---
  function initProductSwatchNavigation() {
    let variantContainers = document.querySelectorAll('variant-selects');
    if (variantContainers.length === 0) {
      variantContainers = document.querySelectorAll('.variant-wrapper-color, .product-form__input--color');
    }

    variantContainers.forEach(function (container, index) {
      if (container.hasAttribute(INIT_MARK)) return;
      
      let swatchContainer = null;
      let leftButton = null;
      let rightButton = null;

      if (container.matches('variant-selects') || container.matches('.variant-wrapper-color')) {
        swatchContainer = container.querySelector('.product-form__input--color, .variant-input-wrap-Color, .variant-input-wrap');
        leftButton = container.querySelector('.swatch-navigation-wrapper[navigation="left"]');
        rightButton = container.querySelector('.swatch-navigation-wrapper[navigation="right"]');
      } else {
        swatchContainer = container;
        const parent = container.closest('variant-selects, .variant-wrapper-color, .variant-wrapper, .product-form__input');
        if (parent) {
          leftButton = parent.querySelector('.swatch-navigation-wrapper[navigation="left"]');
          rightButton = parent.querySelector('.swatch-navigation-wrapper[navigation="right"]');
        }
        if (!leftButton || !rightButton) {
          leftButton = container.parentElement.querySelector('.swatch-navigation-wrapper[navigation="left"]');
          rightButton = container.parentElement.querySelector('.swatch-navigation-wrapper[navigation="right"]');
        }
      }

      if (!swatchContainer || !leftButton || !rightButton) return;
      container.setAttribute(INIT_MARK, 'true');

      function updateNavigation() {
        const maxScroll = swatchContainer.scrollWidth - swatchContainer.clientWidth;
        const scrollLeft = swatchContainer.scrollLeft;

        if (scrollLeft <= 5) {
          leftButton.classList.remove('star-show');
        } else {
          leftButton.classList.add('star-show');
        }

        if (scrollLeft >= maxScroll - 5 || maxScroll <= 0) {
          rightButton.classList.remove('star-show');
        } else {
          rightButton.classList.add('star-show');
        }
      }

      rightButton.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const maxScroll = swatchContainer.scrollWidth - swatchContainer.clientWidth;
        swatchContainer.scrollTo({
          left: Math.min(swatchContainer.scrollLeft + SCROLL_AMOUNT_PRODUCT, maxScroll),
          behavior: 'smooth'
        });
      });

      leftButton.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        swatchContainer.scrollTo({
          left: Math.max(swatchContainer.scrollLeft - SCROLL_AMOUNT_PRODUCT, 0),
          behavior: 'smooth'
        });
      });

      swatchContainer.addEventListener('scroll', updateNavigation);
      window.addEventListener('resize', updateNavigation);
      updateNavigation();
    });
  }

  // --- Batch initializer for all uninit'd grid cards ---
  function initAllGridCards(root = document) {
    root.querySelectorAll('.grid-product__content:not([' + INIT_MARK + '])').forEach(initGridSwatchNavigation);
  }

  // --- Initial run ---
  initAllGridCards();
  initProductSwatchNavigation();

  // --- MutationObserver: catches dynamically loaded sections (recommendations, quick view, etc.) ---
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) { // Element node
          if (node.matches?.('.grid-product__content') || node.querySelector?.('.grid-product__content')) {
            shouldInit = true;
            break;
          }
          // Also check for product page variant containers loaded via ajax
          if (node.matches?.('variant-selects, .variant-wrapper-color, .product-form__input--color') || 
              node.querySelector?.('variant-selects, .variant-wrapper-color, .product-form__input--color')) {
            shouldInit = true;
            break;
          }
        }
      }
      if (shouldInit) break;
    }
    if (shouldInit) {
      initAllGridCards();
      initProductSwatchNavigation();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // --- Theme Editor support ---
  document.addEventListener('shopify:section:load', function(evt) {
    initAllGridCards(evt.target);
    initProductSwatchNavigation();
  });

})();